// extracted by mini-css-extract-plugin
export default {"header":"iiNIEs","username":"n1zwYC","date":"Q63Xnw","rating":"hMfPZD","comment":"KDI0jn","show":"M3_kPF","photoList":"K4Eq0e","photoButton":"XfMgD9","photo":"S5p8ao"};